import { z } from 'zod';
export const schemaCreationInterventionReseau = z.object({
  incident_id: z.string().uuid(),
  affectation_id: z.string().uuid(),
  equipe_id: z.string().uuid().nullable().default(null),
  titre: z.string().trim().min(5).max(200),
  consignes: z.string().trim().min(3).max(4000),
});
export const schemaActionInterventionReseau = z
  .object({
    action: z.enum([
      'accepter',
      'commencer',
      'bloquer',
      'rapport',
      'valider',
      'rejeter',
      'annuler',
    ]),
    version: z.number().int().positive(),
    commentaire: z.string().trim().min(3).max(4000),
    observations: z.string().trim().max(4000).default(''),
    travaux: z.string().trim().max(4000).default(''),
    resultat: z.enum(['RESTORED', 'PARTIAL', 'NOT_RESTORED', 'TEMPORARY']).optional(),
    consommations: z
      .array(
        z.object({
          article_id: z.string().uuid(),
          quantite: z.number().int().min(1).max(1000000),
        }),
      )
      .max(50)
      .default([]),
  })
  .superRefine((d, c) => {
    if (new Set(d.consommations.map((p) => p.article_id)).size !== d.consommations.length)
      c.addIssue({
        code: 'custom',
        message: 'Regroupez les quantités d’un même article sur une seule ligne',
      });
    if (d.action !== 'rapport' && d.consommations.length)
      c.addIssue({ code: 'custom', message: 'Les consommations se déclarent dans le rapport' });
    if (
      d.action === 'rapport' &&
      (!d.resultat || d.observations.length < 3 || d.travaux.length < 3)
    )
      c.addIssue({ code: 'custom', message: 'Un rapport exige observations, travaux et résultat' });
  });
